
import { PasswordValidatorComponent } from './password-validator.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  declarations: [PasswordValidatorComponent],
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe, TranslateDirective, InputTextModule],
  exports: [PasswordValidatorComponent, TranslatePipe, TranslateDirective, InputTextModule]
})
export class PasswordValidatorModule { }


